var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"mb-2",attrs:{"color":"primary","dark":""},on:{"click":function($event){return _vm.getCertificate()}}},[_vm._v(" CERTIFICADO ")])
}
var staticRenderFns = []

export { render, staticRenderFns }